import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../features/auth/store/authStore';
import SupportWrapper from '../../features/support/components/SupportWrapper';
import TutorWrapper from '../../features/tutor/components/TutorWrapper';

// Protected route component that checks for authentication
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login page but save the attempted url
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  // Wrap authenticated content with SupportWrapper and TutorWrapper to provide chat functionality
  return (
    <TutorWrapper>
      <SupportWrapper>{children}</SupportWrapper>
    </TutorWrapper>
  );
};

export default ProtectedRoute;
